export enum VoucherStatus {
  Unused = 0,
  Used = 1,
  Expired = 2,
}
